export enum ContentStatus {
  ACTIVE = 'ACTIVE',
  ACTIVATING = 'ACTIVATING',
  DEACTIVATING = 'DEACTIVATING',
  SUSPEND = 'SUSPEND',
  INACTIVE = 'INACTIVE',
  ARCHIVE = 'ARCHIVE',
  NOT_FOUND = 'NOT_FOUND'
}
